



















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import GlueEditComp from "@/components/GlueEditComp.vue";
@Component({
  components: {
    GlueEditComp,
    Dialog,
    ErrorList
  }
})
export default class GlueEdit extends HacoCommon {
  // put something
}
